import React, { PropTypes } from 'react';
import cx from 'classnames';

import Spinner from 'components/Spinner';

class LoadingOverlay extends React.Component {
  static defaultProps = {
    open: true,
    loadingClassName: 'l',
  }
  handleOnClick = (e) => {
    e.preventDefault();
    e.stopPropogation();
    this.props.onClick ? this.props.onClick() : null;
  }
  render() {
    let { open, loadingClassName, className,  } = this.props;
    return (
      <div className={cx("loading-overlay", className, { open })} onClick={this.handleOnClick}>
        { open && 
          <Spinner className={loadingClassName} />}
      </div>);
  }
};
export { LoadingOverlay as default };